<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2026. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: ztn-backtop.vue
  - Created by: chan.ying
  - Create Date: 2026-07-01
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<template>
  <transition name="ztn-backtop-fade">
    <div v-show="visible" class="ztn-backtop" :style="{ right: this.right, bottom: this.bottom }" @click="scrollToTop">
      <img
          src="@/assets/icons/menu/chevron-up.svg"
          alt=""
          class="ztn-backtop-icon"
      />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ztn-backtop',
  props: {
    right: {type: String, default: '100px'},
    bottom: {type: String, default: '150px'},
    threshold: {type: Number, default: 200}
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleScroll, true);
    });
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll, true);
  },
  methods: {
    handleScroll() {
      this.visible = window.scrollY > this.threshold;
    },
    scrollToTop() {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  }
}
</script>

<style scoped>
.ztn-backtop {
  position: fixed;
  width: var(--control-height-lg);
  height: var(--control-height-lg);
  background: var(--base-primary-3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: var(--elevation-md);
  transition: all 0.3s;
  z-index: 2000;
}

.ztn-backtop:hover {
  background: var(--base-primary-2);
  box-shadow: var(--elevation-lg);
}

.ztn-backtop-icon {
  width: var(--icon-size-lg);
  height: var(--icon-size-lg);
}
</style>
